/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const createScheduleBodyTimeZoneDefault = `Europe/Amsterdam`;
export const createScheduleBodyTimeZoneMax = 100;

export const createScheduleBodyRoutinesItemStartLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const createScheduleBodyRoutinesItemAnchorClockLocalRegExp = new RegExp(
  '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const createScheduleBodyRoutinesItemRotationCountExclusiveMin = 0;
export const createScheduleBodyRoutinesItemRotationCountMax = 2147483647;

export const createScheduleBodyRoutinesItemSectionsItemStartWeekdayMax = 7;

export const createScheduleBodyRoutinesItemSectionsItemStartLocalMinuteMin = 0;
export const createScheduleBodyRoutinesItemSectionsItemStartLocalMinuteMax = 1439;

export const createScheduleBodyRoutinesItemSectionsItemEndWeekdayMax = 7;

export const createScheduleBodyRoutinesItemSectionsItemEndLocalMinuteMin = 0;
export const createScheduleBodyRoutinesItemSectionsItemEndLocalMinuteMax = 1439;

export const createScheduleBodyRoutinesItemSectionsItemFullWeekDefault = false;
export const createScheduleBodyRoutinesItemSectionsMax = 14;

export const createScheduleBodyRoutinesItemParticipantsItemOrdinalMin = 0;
export const createScheduleBodyRoutinesItemParticipantsItemOrdinalMax = 19;

export const createScheduleBodyRoutinesItemParticipantsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const createScheduleBodyRoutinesItemParticipantsMax = 20;

export const createScheduleBodyRoutinesItemEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const createScheduleBodyRoutinesMax = 10;

export const CreateScheduleBody = zod.object({
  teamId: zod.unknown().optional(),
  scheduleId: zod.unknown().optional(),
  name: zod.string(),
  timeZone: zod
    .string()
    .min(1)
    .max(createScheduleBodyTimeZoneMax)
    .default(createScheduleBodyTimeZoneDefault),
  routines: zod
    .array(
      zod.object({
        name: zod.string(),
        startLocalDate: zod.iso.date().regex(createScheduleBodyRoutinesItemStartLocalDateRegExp),
        anchorClockLocal: zod.string().regex(createScheduleBodyRoutinesItemAnchorClockLocalRegExp),
        rotation: zod.object({
          unit: zod.enum(['day', 'week']),
          count: zod
            .int()
            .gt(createScheduleBodyRoutinesItemRotationCountExclusiveMin)
            .max(createScheduleBodyRoutinesItemRotationCountMax),
        }),
        sections: zod
          .array(
            zod.object({
              startWeekday: zod
                .int()
                .min(1)
                .max(createScheduleBodyRoutinesItemSectionsItemStartWeekdayMax),
              startLocalMinute: zod
                .int()
                .min(createScheduleBodyRoutinesItemSectionsItemStartLocalMinuteMin)
                .max(createScheduleBodyRoutinesItemSectionsItemStartLocalMinuteMax),
              endWeekday: zod
                .int()
                .min(1)
                .max(createScheduleBodyRoutinesItemSectionsItemEndWeekdayMax),
              endLocalMinute: zod
                .int()
                .min(createScheduleBodyRoutinesItemSectionsItemEndLocalMinuteMin)
                .max(createScheduleBodyRoutinesItemSectionsItemEndLocalMinuteMax),
              fullWeek: zod
                .boolean()
                .default(createScheduleBodyRoutinesItemSectionsItemFullWeekDefault),
            }),
          )
          .min(1)
          .max(createScheduleBodyRoutinesItemSectionsMax),
        participants: zod
          .array(
            zod.object({
              ordinal: zod
                .int()
                .min(createScheduleBodyRoutinesItemParticipantsItemOrdinalMin)
                .max(createScheduleBodyRoutinesItemParticipantsItemOrdinalMax),
              userId: zod.uuid().regex(createScheduleBodyRoutinesItemParticipantsItemUserIdRegExp),
            }),
          )
          .min(1)
          .max(createScheduleBodyRoutinesItemParticipantsMax),
        endedAt: zod
          .union([
            zod.iso
              .datetime({ offset: true })
              .regex(createScheduleBodyRoutinesItemEndedAtOneRegExp),
            zod.null(),
          ])
          .optional(),
      }),
    )
    .max(createScheduleBodyRoutinesMax)
    .optional(),
});

export type CreateScheduleBody = zod.input<typeof CreateScheduleBody>;
export type CreateScheduleBodyOutput = zod.output<typeof CreateScheduleBody>;
